/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { IVCSBaseService } from '../ivcs-base-service';
import { IVCSApiConfiguration } from '../ivcs-api-configuration';
import { IVCSStrictHttpResponse } from '../ivcs-strict-http-response';

import { consumerCreatePharmacistPost$Json } from '../fn/consumer/consumer-create-pharmacist-post-json';
import { ConsumerCreatePharmacistPost$Json$Params } from '../fn/consumer/consumer-create-pharmacist-post-json';
import { consumerCreatePharmacistPost$Plain } from '../fn/consumer/consumer-create-pharmacist-post-plain';
import { ConsumerCreatePharmacistPost$Plain$Params } from '../fn/consumer/consumer-create-pharmacist-post-plain';
import { consumerGetPrescriptionIdGet$Json } from '../fn/consumer/consumer-get-prescription-id-get-json';
import { ConsumerGetPrescriptionIdGet$Json$Params } from '../fn/consumer/consumer-get-prescription-id-get-json';
import { consumerGetPrescriptionIdGet$Plain } from '../fn/consumer/consumer-get-prescription-id-get-plain';
import { ConsumerGetPrescriptionIdGet$Plain$Params } from '../fn/consumer/consumer-get-prescription-id-get-plain';
import { consumerPharmacistVerifiedGet$Json } from '../fn/consumer/consumer-pharmacist-verified-get-json';
import { ConsumerPharmacistVerifiedGet$Json$Params } from '../fn/consumer/consumer-pharmacist-verified-get-json';
import { consumerPharmacistVerifiedGet$Plain } from '../fn/consumer/consumer-pharmacist-verified-get-plain';
import { ConsumerPharmacistVerifiedGet$Plain$Params } from '../fn/consumer/consumer-pharmacist-verified-get-plain';
import { consumerUpdatePharmacistPost$Json } from '../fn/consumer/consumer-update-pharmacist-post-json';
import { ConsumerUpdatePharmacistPost$Json$Params } from '../fn/consumer/consumer-update-pharmacist-post-json';
import { consumerUpdatePharmacistPost$Plain } from '../fn/consumer/consumer-update-pharmacist-post-plain';
import { ConsumerUpdatePharmacistPost$Plain$Params } from '../fn/consumer/consumer-update-pharmacist-post-plain';
import { consumerUpdatePrescriptionItemsPost$Json } from '../fn/consumer/consumer-update-prescription-items-post-json';
import { ConsumerUpdatePrescriptionItemsPost$Json$Params } from '../fn/consumer/consumer-update-prescription-items-post-json';
import { consumerUpdatePrescriptionItemsPost$Plain } from '../fn/consumer/consumer-update-prescription-items-post-plain';
import { ConsumerUpdatePrescriptionItemsPost$Plain$Params } from '../fn/consumer/consumer-update-prescription-items-post-plain';
import { Pharmacist } from '../models/pharmacist';
import { PrescriptionModel } from '../models/prescription-model';
import { RxItemModel } from '../models/rx-item-model';

@Injectable({ providedIn: 'root' })
export class IVCSConsumerService extends IVCSBaseService {
  constructor(config: IVCSApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `consumerCreatePharmacistPost()` */
  static readonly ConsumerCreatePharmacistPostPath = '/Consumer/CreatePharmacist';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consumerCreatePharmacistPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  consumerCreatePharmacistPost$Plain$Response(params?: ConsumerCreatePharmacistPost$Plain$Params, context?: HttpContext): Observable<IVCSStrictHttpResponse<Pharmacist>> {
    return consumerCreatePharmacistPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consumerCreatePharmacistPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  consumerCreatePharmacistPost$Plain(params?: ConsumerCreatePharmacistPost$Plain$Params, context?: HttpContext): Observable<Pharmacist> {
    return this.consumerCreatePharmacistPost$Plain$Response(params, context).pipe(
      map((r: IVCSStrictHttpResponse<Pharmacist>): Pharmacist => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consumerCreatePharmacistPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  consumerCreatePharmacistPost$Json$Response(params?: ConsumerCreatePharmacistPost$Json$Params, context?: HttpContext): Observable<IVCSStrictHttpResponse<Pharmacist>> {
    return consumerCreatePharmacistPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consumerCreatePharmacistPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  consumerCreatePharmacistPost$Json(params?: ConsumerCreatePharmacistPost$Json$Params, context?: HttpContext): Observable<Pharmacist> {
    return this.consumerCreatePharmacistPost$Json$Response(params, context).pipe(
      map((r: IVCSStrictHttpResponse<Pharmacist>): Pharmacist => r.body)
    );
  }

  /** Path part for operation `consumerPharmacistVerifiedGet()` */
  static readonly ConsumerPharmacistVerifiedGetPath = '/Consumer/PharmacistVerified';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consumerPharmacistVerifiedGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerPharmacistVerifiedGet$Plain$Response(params?: ConsumerPharmacistVerifiedGet$Plain$Params, context?: HttpContext): Observable<IVCSStrictHttpResponse<boolean>> {
    return consumerPharmacistVerifiedGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consumerPharmacistVerifiedGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerPharmacistVerifiedGet$Plain(params?: ConsumerPharmacistVerifiedGet$Plain$Params, context?: HttpContext): Observable<boolean> {
    return this.consumerPharmacistVerifiedGet$Plain$Response(params, context).pipe(
      map((r: IVCSStrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consumerPharmacistVerifiedGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerPharmacistVerifiedGet$Json$Response(params?: ConsumerPharmacistVerifiedGet$Json$Params, context?: HttpContext): Observable<IVCSStrictHttpResponse<boolean>> {
    return consumerPharmacistVerifiedGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consumerPharmacistVerifiedGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerPharmacistVerifiedGet$Json(params?: ConsumerPharmacistVerifiedGet$Json$Params, context?: HttpContext): Observable<boolean> {
    return this.consumerPharmacistVerifiedGet$Json$Response(params, context).pipe(
      map((r: IVCSStrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `consumerUpdatePharmacistPost()` */
  static readonly ConsumerUpdatePharmacistPostPath = '/Consumer/UpdatePharmacist';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consumerUpdatePharmacistPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  consumerUpdatePharmacistPost$Plain$Response(params?: ConsumerUpdatePharmacistPost$Plain$Params, context?: HttpContext): Observable<IVCSStrictHttpResponse<Pharmacist>> {
    return consumerUpdatePharmacistPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consumerUpdatePharmacistPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  consumerUpdatePharmacistPost$Plain(params?: ConsumerUpdatePharmacistPost$Plain$Params, context?: HttpContext): Observable<Pharmacist> {
    return this.consumerUpdatePharmacistPost$Plain$Response(params, context).pipe(
      map((r: IVCSStrictHttpResponse<Pharmacist>): Pharmacist => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consumerUpdatePharmacistPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  consumerUpdatePharmacistPost$Json$Response(params?: ConsumerUpdatePharmacistPost$Json$Params, context?: HttpContext): Observable<IVCSStrictHttpResponse<Pharmacist>> {
    return consumerUpdatePharmacistPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consumerUpdatePharmacistPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  consumerUpdatePharmacistPost$Json(params?: ConsumerUpdatePharmacistPost$Json$Params, context?: HttpContext): Observable<Pharmacist> {
    return this.consumerUpdatePharmacistPost$Json$Response(params, context).pipe(
      map((r: IVCSStrictHttpResponse<Pharmacist>): Pharmacist => r.body)
    );
  }

  /** Path part for operation `consumerGetPrescriptionIdGet()` */
  static readonly ConsumerGetPrescriptionIdGetPath = '/Consumer/GetPrescription/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consumerGetPrescriptionIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerGetPrescriptionIdGet$Plain$Response(params: ConsumerGetPrescriptionIdGet$Plain$Params, context?: HttpContext): Observable<IVCSStrictHttpResponse<PrescriptionModel>> {
    return consumerGetPrescriptionIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consumerGetPrescriptionIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerGetPrescriptionIdGet$Plain(params: ConsumerGetPrescriptionIdGet$Plain$Params, context?: HttpContext): Observable<PrescriptionModel> {
    return this.consumerGetPrescriptionIdGet$Plain$Response(params, context).pipe(
      map((r: IVCSStrictHttpResponse<PrescriptionModel>): PrescriptionModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consumerGetPrescriptionIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerGetPrescriptionIdGet$Json$Response(params: ConsumerGetPrescriptionIdGet$Json$Params, context?: HttpContext): Observable<IVCSStrictHttpResponse<PrescriptionModel>> {
    return consumerGetPrescriptionIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consumerGetPrescriptionIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerGetPrescriptionIdGet$Json(params: ConsumerGetPrescriptionIdGet$Json$Params, context?: HttpContext): Observable<PrescriptionModel> {
    return this.consumerGetPrescriptionIdGet$Json$Response(params, context).pipe(
      map((r: IVCSStrictHttpResponse<PrescriptionModel>): PrescriptionModel => r.body)
    );
  }

  /** Path part for operation `consumerUpdatePrescriptionItemsPost()` */
  static readonly ConsumerUpdatePrescriptionItemsPostPath = '/Consumer/UpdatePrescriptionItems';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consumerUpdatePrescriptionItemsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  consumerUpdatePrescriptionItemsPost$Plain$Response(params?: ConsumerUpdatePrescriptionItemsPost$Plain$Params, context?: HttpContext): Observable<IVCSStrictHttpResponse<Array<RxItemModel>>> {
    return consumerUpdatePrescriptionItemsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consumerUpdatePrescriptionItemsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  consumerUpdatePrescriptionItemsPost$Plain(params?: ConsumerUpdatePrescriptionItemsPost$Plain$Params, context?: HttpContext): Observable<Array<RxItemModel>> {
    return this.consumerUpdatePrescriptionItemsPost$Plain$Response(params, context).pipe(
      map((r: IVCSStrictHttpResponse<Array<RxItemModel>>): Array<RxItemModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consumerUpdatePrescriptionItemsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  consumerUpdatePrescriptionItemsPost$Json$Response(params?: ConsumerUpdatePrescriptionItemsPost$Json$Params, context?: HttpContext): Observable<IVCSStrictHttpResponse<Array<RxItemModel>>> {
    return consumerUpdatePrescriptionItemsPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consumerUpdatePrescriptionItemsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  consumerUpdatePrescriptionItemsPost$Json(params?: ConsumerUpdatePrescriptionItemsPost$Json$Params, context?: HttpContext): Observable<Array<RxItemModel>> {
    return this.consumerUpdatePrescriptionItemsPost$Json$Response(params, context).pipe(
      map((r: IVCSStrictHttpResponse<Array<RxItemModel>>): Array<RxItemModel> => r.body)
    );
  }

}
